import { AxiosRequestConfig } from 'axios';
import { DepartmentUser, UpdateDepartment, UpdateDepartmentLocation } from '../types';

const endpoint = 'api/departments';

export default {
    retrieveLocation: (id: number) => ({ method: 'GET', url: `${endpoint}/${id}/location` } as AxiosRequestConfig),
    updateDepartment: (id: number, data: UpdateDepartment) =>
        ({ method: 'PUT', url: `${endpoint}/${id}`, data } as AxiosRequestConfig),
    updateDepartmentLocation: (id: number, data: UpdateDepartmentLocation) =>
        ({ method: 'PUT', url: `${endpoint}/${id}/location`, data } as AxiosRequestConfig),
    addUser: (id: number, data: DepartmentUser) =>
        ({ method: 'POST', url: `${endpoint}/${id}/users`, data } as AxiosRequestConfig),
    removeUser: (id: number, userId: number) =>
        ({ method: 'DELETE', url: `${endpoint}/${id}/users/${userId}` } as AxiosRequestConfig),
};
